module.exports = __webpack_public_path__ + "static/media/2-4-2_Spot_UV_Matt_01.6960b082.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-4-2_Spot_UV_Matt_01.jpg
// module id = 1727
// module chunks = 0